import {
  GET_PROCESSING_FEE_PENDING,
  GET_PROCESSING_FEE_FULFILLED,
  GET_PROCESSING_FEE_FAILED,
  RESET_PROCESSING_FEE,
} from "constants-lib/actionTypes"

const initialState = {
  processingFeeDetails: {},
  processingFeeState: ``,
  errorMessage: ``,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROCESSING_FEE_PENDING:
      return {
        ...state,
        processingFeeState: `pending`,
      }
    case GET_PROCESSING_FEE_FULFILLED:
      return {
        ...state,
        processingFeeDetails: action.payload,
        processingFeeState: `fulfilled`,
      }
    case GET_PROCESSING_FEE_FAILED:
      return {
        ...state,
        ...initialState,
        errorMessage: action.payload.errorMessage,
        processingFeeState: `failed`,
      }
    case RESET_PROCESSING_FEE:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}
